"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidePanel = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const Overlay_1 = require("../Overlay");
const Target_1 = require("../Target");
const SidePanel = (props) => {
    const { children, position = "end", title, visible, onDismiss } = props;
    const [, setForceUpdate] = react_1.default.useState(0);
    const [hasTransitionedOut, setHasTransitionedOut] = react_1.default.useState(true);
    const handleTransitionEnd = react_1.default.useCallback((e) => {
        if (!visible && e.target === e.currentTarget) {
            setHasTransitionedOut(true);
        }
    }, [visible]);
    react_1.default.useEffect(() => {
        // Force a render on mount so the element exists and
        // transitions start working
        setForceUpdate(1);
    }, []);
    react_1.default.useEffect(() => {
        if (visible && hasTransitionedOut) {
            setHasTransitionedOut(false);
        }
    }, [hasTransitionedOut, visible]);
    return (react_1.default.createElement(Overlay_1.Overlay, { visible: visible, onDismiss: onDismiss },
        react_1.default.createElement(foundations_1.Box, { "aria-hidden": !visible, "data-testid": "side-panel", role: "dialog", sx: {
                height: 0,
                left: 0,
                overflow: "visible",
                position: "fixed",
                top: 0,
                width: "100%"
            } },
            react_1.default.createElement(foundations_1.Grid, { initial: true, sx: {
                    height: 0,
                    overflow: "visible"
                }, variant: "navigation" },
                react_1.default.createElement(foundations_1.GridColumn, { fillEnd: position === "end", fillGapEnd: position === "end", fillGapStart: true, fillStart: position === "start", onTransitionEnd: handleTransitionEnd, push: position === "end" ? [0, 4, 8] : [0, 0, 0], size: [4, 4, 4], sx: {
                        bg: "white",
                        boxShadow: "shadow-100",
                        height: hasTransitionedOut ? 0 : "100vh",
                        opacity: !visible ? 0 : 1,
                        transition: ["easeOutMedium", null, "easeOutFast"],
                        transform: !visible ? "translateX(150px)" : "none"
                    } }, hasTransitionedOut ? null : (react_1.default.createElement(foundations_1.Box, { sx: {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        maxHeight: "100vh",
                        pt: "spacing-5",
                        px: "spacing-5"
                    } },
                    react_1.default.createElement(foundations_1.Box, { sx: {
                            display: "flex",
                            justifyContent: title ? "space-between" : "end",
                            pb: "spacing-3",
                            width: "100%"
                        } },
                        title && react_1.default.createElement(TextV2_1.TextV2, { variant: "title-2-medium" }, title),
                        react_1.default.createElement(Target_1.Target, { autoFocus: true, "data-testid": "side-panel-dismiss", onClick: onDismiss, "aria-label": "close side panel" },
                            react_1.default.createElement(foundations_1.IconV2, { icon: "x", size: "sm" }))),
                    react_1.default.createElement(foundations_1.Box, { sx: {
                            display: "flex",
                            flexDirection: "column",
                            flexGrow: 1,
                            overflow: "auto",
                            WebkitOverflowScrolling: "touch"
                        } }, children))))))));
};
exports.SidePanel = SidePanel;
//# sourceMappingURL=SidePanel.js.map